import React, { useState, lazy, Suspense } from 'react';
import DashboardLayout from '@/components/DashboardLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card } from '@/components/ui/card';
import { LayoutDashboard, TrendingUp, AlertTriangle, FileText, ClipboardList, Loader2 } from 'lucide-react';

// Import content components from existing pages
import { PurchaseDashboardContent } from './PurchaseDashboardPage';
import { ProcurementTrackingContent } from './ProcurementTrackingPage';
import { PODiscrepancyContent } from './PODiscrepancyPage';
import { InvoiceReportContent } from './InvoiceReportPage';
import { GRNRegisterContent } from './GRNRegisterPage';

const LoadingSpinner = () => (
  <div className="flex items-center justify-center py-20">
    <Loader2 className="w-8 h-8 animate-spin text-muted-foreground" />
  </div>
);

export default function PurchaseReportsPage() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { id: 'procurement', label: 'Procurement', icon: TrendingUp },
    { id: 'discrepancies', label: 'Discrepancies', icon: AlertTriangle },
    { id: 'invoices', label: 'Invoices', icon: FileText },
    { id: 'grn', label: 'GRN Register', icon: ClipboardList },
  ];

  return (
    <DashboardLayout>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Purchase Reports</h1>
          <p className="text-muted-foreground text-sm mt-1">
            Dashboard, Procurement Tracking, PO Discrepancies, Invoices & GRN Register
          </p>
        </div>

        <Card>
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <div className="border-b px-4">
              <TabsList className="h-12 bg-transparent gap-2">
                {tabs.map(tab => (
                  <TabsTrigger
                    key={tab.id}
                    value={tab.id}
                    className="data-[state=active]:bg-primary data-[state=active]:text-primary-foreground px-4 py-2 gap-2"
                  >
                    <tab.icon className="w-4 h-4" />
                    {tab.label}
                  </TabsTrigger>
                ))}
              </TabsList>
            </div>

            <div className="p-4">
              <TabsContent value="dashboard" className="mt-0">
                <PurchaseDashboardContent />
              </TabsContent>
              <TabsContent value="procurement" className="mt-0">
                <ProcurementTrackingContent />
              </TabsContent>
              <TabsContent value="discrepancies" className="mt-0">
                <PODiscrepancyContent />
              </TabsContent>
              <TabsContent value="invoices" className="mt-0">
                <InvoiceReportContent />
              </TabsContent>
              <TabsContent value="grn" className="mt-0">
                <GRNRegisterContent />
              </TabsContent>
            </div>
          </Tabs>
        </Card>
      </div>
    </DashboardLayout>
  );
}
